import { Archive } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ArchiveIcon = createLucideIcon(Archive);
